import { P0, S, abs, fillAt, max } from '../../geometry';

export const rocket = {
  name: 'Rocket',
  colors: ['#8E4EC6', '#E5484D'],
  draw(m, t) {
    let fl = 8 + 2 * S(t * 11),
      jx = 0,
      lift = 1.5 * S(t * 1.4),
      pose = P0();
    if (m === 'happy') {
      fl = 16 + 4 * S(t * 14);
      lift = -4 * abs(S(t * 6));
    }
    // Thinking: rumbles on the pad, flame roaring.
    if (m === 'thinking') {
      fl = 14 + 5 * S(t * 17) + 2 * S(t * 29);
      jx = 1.2 * S(t * 31);
    }
    if (m === 'talking') fl = 8 + 8 * max(0, S(t * 10));
    if (m === 'surprised') {
      fl = 22 + 2 * S(t * 30);
      lift = -8;
    }
    if (m === 'paused') {
      fl = 0.01;
      lift = 3;
    }
    const sh = ([x, y]) => [x + jx, y + lift];
    const body = [
      [50, 10],
      [61, 23],
      [65, 58],
      [35, 58],
      [39, 23],
      [50, 10],
    ].map(sh);
    const flame = [
      [42, 60],
      [45, 60 + fl * 0.6],
      [50, 60 + fl],
      [55, 60 + fl * 0.6],
      [58, 60],
    ].map(sh);
    return {
      strokes: [
        { c: 'a', pts: body, n: 30 },
        {
          c: 'a',
          pts: [
            [37, 46],
            [26, 63],
            [36, 60],
          ].map(sh),
          sharp: true,
        },
        {
          c: 'a',
          pts: [
            [63, 46],
            [74, 63],
            [64, 60],
          ].map(sh),
          sharp: true,
        },
        { c: 'b', pts: flame, o: m === 'paused' ? 0 : 1 },
      ],
      eyes: { x: 50 + jx, y: 38 + lift },
      pose,
    };
  },
  eyesOn: 'a',
  solid(f) {
    fillAt(f, 0, 1, 2);
    const fl = f.strokes[3];
    fl.pts = fl.pts.map(([x, y], i, all) => [
      50 + (x - 50) * 0.7,
      y + 6 + (i === 0 || i === all.length - 1 ? 0 : 0),
    ]);
    return f;
  },
};
